import * as Types from './institutionsActionTypes';

export function updateInstitution(data, onSuccess, onFail) {
  return { type: Types.UPDATE_INSTITUTION, data, onSuccess, onFail };
}

export function updateInstitutionSuccess(institution) {
  return { type: Types.UPDATE_INSTITUTION_SUCCESS, institution };
}

export function updateInstitutionFailure(error) {
  return { type: Types.UPDATE_INSTITUTION_FAILURE, error };
}



// WEBPACK FOOTER //
// ./src/redux/actions/institutionsActions.js